import React from 'react';
import type { BennieClient } from '../clients/BennieClient';

export interface BennieServices {
  api: BennieClient;
}

const BennieClientContext = React.createContext<BennieServices | null>(null);

export function BennieClientProvider(props: { value: BennieServices; children: React.ReactNode }) {
  return <BennieClientContext.Provider value={props.value}>{props.children}</BennieClientContext.Provider>;
}

// eslint-disable-next-line react-refresh/only-export-components -- HMR-only opt-out: this hook is imported by 20+ call sites; moving it to a sibling file would ripple edits into out-of-scope files. No runtime impact.
export function useBennieServices(): BennieServices {
  const ctx = React.useContext(BennieClientContext);
  if (!ctx) {
    throw new Error('useBennieServices must be used within BennieClientProvider');
  }
  return ctx;
}


